// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dragging{opacity:.6;transform:scale(.98)}.drag-over{border:2px dashed #4a9eff;background-color:rgba(74,158,255,.1);transition:all .2s ease}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
